import { ImportedCustomEventSchema, SchemaAttribute } from "types/customEvents";
import { array, boolean, object, string } from "yup";

const customEventSchemaJson = object({
  eventType: string().required(),
  name: string().required(),
  schema: object({
    fields: array().of(
      object({
        description: string(),
        name: string(),
        type: string(),
      }),
    ),
  }).required(),
  active: boolean(),
});

export const isCustomEventSchemaJsonValid = (
  customEventSchema: ImportedCustomEventSchema,
) => {
  try {
    customEventSchemaJson.validateSync(customEventSchema);
    return true;
  } catch {
    return false;
  }
};

export const countSchemaObject = (
  attribute: SchemaAttribute,
  count: number = 0,
): number => {
  const isComplexAttribute =
    attribute.type === "object" || attribute.type === "collection";

  if (!isComplexAttribute) {
    return 1;
  }

  if (attribute.itemType) {
    return attribute.itemType.fields
      ? attribute.itemType.fields
          .map((attr) => countSchemaObject(attr, attribute.fields?.length))
          .reduce((a, b) => a + b)
      : count;
  }

  return attribute.fields
    ? attribute.fields
        .map((attr) => countSchemaObject(attr, attribute.fields?.length))
        .reduce((a, b) => a + b)
    : count;
};
